import {DIALOG_TYPE, LayoutConfig} from '@spartacus/storefront';
import {BehaviorSubject, Observable} from 'rxjs';

import {AimoProduct} from '../../../model/product.model';
import {AimoGTMProductAttributes} from '../../../service/gtm/aimo-gtm.model';

import {AimoProductSummaryComponent} from './aimo-product-summary.component';

export const PRODUCT_SUMMARY = 'PRODUCT_SUMMARY';

export const productSummaryLayout: LayoutConfig = {
    launch: {
        PRODUCT_SUMMARY: {
            inlineRoot: true,
            component: AimoProductSummaryComponent,
            dialogType: DIALOG_TYPE.DIALOG,
        },
    },
};

export interface AimoProductSummaryDialogData {
    product: Observable<AimoProduct>;
    scrollToId?: string;
    addToCartCallBack: BehaviorSubject<number>;
    onProductChangeCallBack: BehaviorSubject<AimoProduct>;
    openModalAfterClose?: string;
    focusIdAfterClose?: string;
    gtmProductAttributes?: AimoGTMProductAttributes;
}
